import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "nge-tetris" }
const _hoisted_2 = { class: "nge-tetris-well" }
const _hoisted_3 = {
  ref: "canvasEl",
  class: "nge-tetris-canvas",
  tabindex: "0"
}
const _hoisted_4 = {
  key: 0,
  class: "nge-tetris-overlay"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "nge-tetris-big" }, "Neuron Tetris", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Stack the neuron pieces. Fill a row to merge it.", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "nge-tetris-small" }, "or press Enter", -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "nge-tetris-big" }, "Paused", -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "nge-tetris-small" }, "or press P", -1 /* HOISTED */)
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "nge-tetris-big" }, "Game over", -1 /* HOISTED */)
const _hoisted_12 = {
  key: 0,
  class: "nge-tetris-best-note"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "nge-tetris-side" }
const _hoisted_15 = { class: "nge-tetris-stat" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Score", -1 /* HOISTED */)
const _hoisted_17 = { class: "nge-tetris-stat" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Best", -1 /* HOISTED */)
const _hoisted_19 = { class: "nge-tetris-stat" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Rows merged", -1 /* HOISTED */)
const _hoisted_21 = { class: "nge-tetris-stat" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "Level", -1 /* HOISTED */)
const _hoisted_23 = { class: "nge-tetris-next" }
const _hoisted_24 = { ref: "nextEl" }
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<ul class=\"nge-tetris-keys\"><li><kbd>←</kbd><kbd>→</kbd> move</li><li><kbd>↑</kbd> or <kbd>X</kbd> turn, <kbd>Z</kbd> back</li><li><kbd>↓</kbd> faster</li><li><kbd>Space</kbd> drop</li><li><kbd>P</kbd> pause</li></ul>", 1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("canvas", _hoisted_3, null, 512 /* NEED_PATCH */),
      ($setup.state !== 'playing')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            ($setup.state === 'ready')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_5,
                  _hoisted_6,
                  _createElementVNode("button", {
                    class: "nge-tetris-start",
                    onClick: $setup.start
                  }, "Start"),
                  _hoisted_7
                ], 64 /* STABLE_FRAGMENT */))
              : ($setup.state === 'paused')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_8,
                    _createElementVNode("button", {
                      class: "nge-tetris-start",
                      onClick: $setup.togglePause
                    }, "Keep playing"),
                    _hoisted_9
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("img", {
                      class: "nge-tetris-over-nurro",
                      src: $setup.nurroPopcorn,
                      alt: "Nurro with popcorn"
                    }, null, 8 /* PROPS */, _hoisted_10),
                    _hoisted_11,
                    _createElementVNode("p", null, _toDisplayString($setup.score.toLocaleString()) + " points, " + _toDisplayString($setup.lines) + " " + _toDisplayString($setup.lines === 1 ? 'row' : 'rows') + " merged", 1 /* TEXT */),
                    ($setup.newBest)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Your best yet!"))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("button", {
                      class: "nge-tetris-start",
                      onClick: $setup.start
                    }, "Play again")
                  ], 64 /* STABLE_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      _createVNode(_Transition, { name: "nge-tetris-cheer" }, {
        default: _withCtx(() => [
          ($setup.cheer)
            ? (_openBlock(), _createElementBlock("div", {
                class: "nge-tetris-cheer",
                key: $setup.cheer.text
              }, [
                _createElementVNode("img", {
                  src: $setup.cheer.img,
                  alt: "Nurro"
                }, null, 8 /* PROPS */, _hoisted_13),
                _createElementVNode("span", null, _toDisplayString($setup.cheer.text), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("b", null, _toDisplayString($setup.score.toLocaleString()), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("b", null, _toDisplayString($setup.best.toLocaleString()), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("b", null, _toDisplayString($setup.lines), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("b", null, _toDisplayString($setup.level), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("span", null, "Next: " + _toDisplayString($setup.nextName), 1 /* TEXT */),
        _createElementVNode("canvas", _hoisted_24, null, 512 /* NEED_PATCH */)
      ]),
      _hoisted_25
    ])
  ]))
}